import { render, staticRenderFns } from "./YjTravel.vue?vue&type=template&id=3ef12664&"
import script from "./YjTravel.vue?vue&type=script&lang=js&"
export * from "./YjTravel.vue?vue&type=script&lang=js&"
import style0 from "./YjTravel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports